import { render, staticRenderFns } from "./stockFlowInventoryDetail.vue?vue&type=template&id=c17a8008&scoped=true"
import script from "./stockFlowInventoryDetail.vue?vue&type=script&lang=js"
export * from "./stockFlowInventoryDetail.vue?vue&type=script&lang=js"
import style0 from "./stockFlowInventoryDetail.vue?vue&type=style&index=0&id=c17a8008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17a8008",
  null
  
)

export default component.exports